import { UserProfile, WalletInfo, WalletItem } from '@/types/user';
import { apiSlice } from './apiSlice';



export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // users/me
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
        params: { t: Date.now() },
        requiresAuth: true,
      }),
      providesTags: ['UserDetails'],
    }),

    // Get current user's wallets
    getUserWallets: builder.query<WalletInfo, void>({
      query: () => ({
        url: '/users/me/wallets',
        method: 'GET',
        params: { t: Date.now() },
        requiresAuth: true,
      }),

      transformResponse: (payload: WalletItem[]): WalletInfo => {
        const balance: WalletInfo = {
          mainBalance: 0,
          bonusBalance: 0,
          exposure: 0,
          lockedAmount: 0,
        };

        payload?.forEach((w) => {
          const type = w?.type?.toLowerCase();

          if (type === 'main') {
            balance.mainBalance = Number(w.amount);
            balance.exposure = Number(w.exposureAmount);
            balance.lockedAmount = Number(w.lockedAmount);
          } else if (type === 'bonus') {
            balance.bonusBalance = Number(w.amount);
          }
        });

        return balance;
      },
    }),
  }),
});

export const { useGetUserProfileQuery, useGetUserWalletsQuery } = userApi;
